import type { DisciplineVerzameling } from '@models/DisciplineVerzameling'

import type { Project } from './types/Project'
import type { QuickscanCombiDiscipline } from './types/QuickscanCombiDiscipline'
import type { QuickscanHoofdleidingDiscipline } from './types/QuickscanHoofdleidingDiscipline'

export const createQuickscanCombiDisciplines = (
  data: DisciplineVerzameling[],
): QuickscanCombiDiscipline[] => {
  const disciplines: QuickscanCombiDiscipline[] = []

  data.forEach((dv) => {
    if (dv.isCombiUitvoeringReden && !dv.isCombiUitvoering) {
      disciplines.push({
        discipline: dv.disciplineLabel,
        answer: false,
        text: dv.isCombiUitvoeringReden,
      })
    }

    if (dv.isCombiUitvoering) {
      disciplines.push({
        discipline: dv.disciplineLabel,
        answer: true,
      })
    }
  })

  return disciplines
}

export const createQuickscanHoofdleidingDisciplines = (
  data: DisciplineVerzameling[],
): QuickscanHoofdleidingDiscipline[] => {
  const disciplines: QuickscanHoofdleidingDiscipline[] = []

  data.forEach((dv) => {
    if (dv.isHoofdleidingAanleggen === true && dv.isHoofdleidingAanleggenText) {
      // text is verplicht als isHoofdleidingAanleggen true is
      disciplines.push({
        discipline: dv.disciplineLabel,
        answer: true,
        text: dv.isHoofdleidingAanleggenText,
      })
    }

    if (dv.isHoofdleidingAanleggen === false) {
      disciplines.push({
        discipline: dv.disciplineLabel,
        answer: false,
      })
    }
  })
  return disciplines
}

export const getAannemers = (project: Project): string[] => {
  const aannemers: Set<string> = new Set()

  if (project.coordAannemer)
    project.coordAannemer.forEach((a) => aannemers.add(a))
  if (project.aannemers) project.aannemers.forEach((a) => aannemers.add(a))

  return Array.from(aannemers)
}
